
import React, { useContext, useState } from "react"

import { useMutation } from "@tanstack/react-query";

import { matchPath, Route, Routes, useNavigate } from "react-router-dom";
import { Empty, notification, Divider, Skeleton } from "antd";

import { useRelativePath } from "../../Hooks/useNextRelativePath";
import { useWatchParameterOnRoutes } from "../../Hooks/useGetParameterOnRoutes";

import { AlunoService } from "../../Services/Domain/Pessoa/AlunoService";
import { Permissoes } from "../../Constants/Permissoes";
import { PropriedadesDeNotificacao } from "../../Utils/Notificacoes";
import { TypeAluno } from "../../Models/Domain/Pessoa/Aluno";
import { useRedirection } from "../../Hooks/useRedirection";
import { ListagemDeAlunos } from "./Listagem/Aluno.listagem";
import { SessaoContext } from "../../Contexts/SessaoContext";
import { CadastroDeAluno } from "../Viagem/Cadastros/Viagem/Componentes/CadastroDeAluno";

const Aluno: React.FC<{}> = (props) => {
    const [alunoEmAlteracao, setAlunoEmAlteracao] = useState<TypeAluno | undefined>(undefined);
    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);

    const navigate = useNavigate();
    const [raiz, subrota] = useRelativePath();

    const rotaDeEdicao = matchPath({ path: "/editar" }, subrota);
    const rotaDeVisualizacao = matchPath({ path: "/detalhes" }, subrota);

    const obterAluno = useMutation({
        mutationFn: (id: number) => new AlunoService().listar({codigo: id}),
        gcTime: 0,
        onSuccess: (resposta) => {
            const resultados = resposta.data;
            if (resultados.length == 0) {
                notification.open({
                    ...PropriedadesDeNotificacao.Erro("Nenhum registro foi encontrado para o identificador informado")
                })
                navigate(raiz)
            } else {
                setAlunoEmAlteracao(resposta.data.at(0))
            }
        }
    })

    useRedirection([Permissoes.ListarAlunos, Permissoes.CriarAluno, Permissoes.AtualizarAluno, Permissoes.AtivarAluno, Permissoes.DesativarAluno])
    useWatchParameterOnRoutes({
        appliablePaths: [rotaDeEdicao, rotaDeVisualizacao], paramToWatch: "id", filters: [(p) => isNaN(Number(p))],
        onNotAccepted() { navigate(raiz) },
        onExists(param) { obterAluno.mutate(Number(param)); },
    })

    return (
        <>
            <h2 style={{ marginTop: 0 }}>
                {
                    rotaDeVisualizacao ? "Detalhes do Aluno" : rotaDeEdicao ? "Edição do Aluno" : "Cadastro do Aluno"
                }
            </h2>

            <Divider />

            <Routes>
                {
                    permissoes?.includes(Permissoes.ListarAlunos) &&
                    <Route path="*" index element={
                        <ListagemDeAlunos
                            hrefDoBotaoAdicionar={raiz + "/cadastro"}
                            hrefDoBotaoEditar={(item) => {
                                if (item.codigo) {
                                    return raiz + `/editar?id=${item.codigo}`
                                }
                            }}

                            aoEditar={(aluno) => {
                                setAlunoEmAlteracao(aluno)
                            }}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.CriarAluno) &&
                    <Route path="/cadastro" element={
                        <CadastroDeAluno privilegio="administrador"
                            aoCancelar={() => navigate(raiz)}
                            depoisDeFinalizar={() => navigate(raiz)}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.AtualizarAluno) &&
                    <Route path="/editar" element={
                        alunoEmAlteracao == undefined ? <Skeleton active /> :
                        <CadastroDeAluno privilegio="administrador"
                            alunoEmAlteracao={alunoEmAlteracao}
                            aoCancelar={() => navigate(raiz)}
                            depoisDeFinalizar={() => navigate(raiz)}
                        />
                    } />
                }
            </Routes>
        </>
    );
}

export default Aluno;